import {API_URL } from '../constants/index.js';
import {
    ADD_DINING_LOCATION,
    ADD_DINING_LOCATION_ERROR,
    ADD_DINING_LOCATION_SUCCESS,
    DELETE_DINING_LOCATION,
    DELETE_DINING_LOCATION_ERROR,
    DELETE_DINING_LOCATION_SUCCESS,
    DINING_LOCATION,
    DINING_LOCATION_ERROR,
    DINING_LOCATION_SUCCESS,
    UPDATE_DINING_LOCATION,
    UPDATE_DINING_LOCATION_ERROR,
    UPDATE_DINING_LOCATION_SUCCESS
} from '../constants/diningLocationConstants';
import { sweetAlert } from '../components/Alert/sweetAlert.jsx';

export function getDiningLocation(data) {
    return {
        type: DINING_LOCATION,
        data
    }
};

export function getDiningLocationSuccess(data) {
    return {
        type: DINING_LOCATION_SUCCESS,
        data
    }
};

export function getDiningLocationError(data) {
    return {
        type: DINING_LOCATION_ERROR,
        data
    }
};


export function GetDiningLocations(idCommunity) {
    return dispatch => {
        dispatch(getDiningLocation());
        
        fetch(API_URL+'diningLocations/locationsByCommunity/'+idCommunity,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
            }
            })
            .then(res => res.json())
            .then(res => {

                if(res.message){
                    dispatch(getDiningLocationError(res.message));    
                } else{

                    dispatch(getDiningLocationSuccess(res));
                }
                return res;
            })
            .catch(error => {
                dispatch(getDiningLocationError(error));

            })
    }
};

function addDiningLocation() {
    return {
        type: ADD_DINING_LOCATION,
    }
};

function addDiningLocationSuccess(data) {
    return {
        type: ADD_DINING_LOCATION_SUCCESS,
        data
    }
};

function addDiningLocationError(data) {
    return {
        type: ADD_DINING_LOCATION_ERROR,
        data
    }
};

export function AddDiningLocation(data) {
    return dispatch => {
        dispatch(addDiningLocation());

        fetch(API_URL+'diningLocations/diningLocation',
            {
                body:JSON.stringify(data),
                method: 'POST',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
            }
            })
            .then(res => res.json())
            .then(res => {


                const message = `The Dining Location has been added successfully`

                sweetAlert('success',message,'alert_Add_DiningLocation_Success');

                dispatch(addDiningLocationSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(addDiningLocationError(error));

            })
    }
};


export function updateDiningLocation(data) {
    return {
        type: UPDATE_DINING_LOCATION,
        data
    }
};

export function updateDiningLocationSuccess(data) {
    return {
        type: UPDATE_DINING_LOCATION_SUCCESS,
        data
    }
};

export function updateDiningLocationError(error) {
    return {
        type: UPDATE_DINING_LOCATION_ERROR,
        error
    }
};

export function UpdateDiningLocation(id,data) {
    return dispatch => {
        dispatch(updateDiningLocation());

        fetch(API_URL+'diningLocations/diningLocation/' + id,
            {
                body:JSON.stringify(data),
                method: 'PUT',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
            }
            })
            .then(res => {
                if(res.status===204){
                    const message = `The Dining Location has been updated successfully`

                    sweetAlert('success',message,'alert_DiningLocation_Update_Success');
    
                    dispatch(updateDiningLocationSuccess(data));
                    
                    return res;
                }else{
                    const message = res.body.message
                    sweetAlert('error',message,'alert_DiningLocation_Update_Success');
    
                    dispatch(updateDiningLocationError(data));
                }
             
            })
            .catch(error => {
                dispatch(updateDiningLocationError(error));

            })
    }
};


function deleteDiningLocation() {
    return {
        type: DELETE_DINING_LOCATION,
        
    }
};

function deleteDiningLocationSuccess(id) {
    return {
        type: DELETE_DINING_LOCATION_SUCCESS,
        data:id

    }
};

function deleteDiningLocationError(error) {
    return {
        type: DELETE_DINING_LOCATION_ERROR,
        error
    }
};

export function DeleteDiningLocation(id) {
    return dispatch => {
        dispatch(deleteDiningLocation());

       
        fetch(API_URL+'diningLocations/diningLocation/' + id,
            {
                method: 'DELETE',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
            }
            })
            .then(res => {
                if(res.status===204){
                    const message = `The dining location has been deleted successfully`

                    sweetAlert('success',message,'alert_dining_location_Delete_Success');
    
                    dispatch(deleteDiningLocationSuccess(id));
                }else{
                    const message = res.body.message

                    sweetAlert('error',message,'alert_dining_location_Delete_Success');
    
                    dispatch(deleteDiningLocationError(id));
                }
         

            })
            .catch(error => {

                dispatch(deleteDiningLocationError(error));
              
                const message = `An error has occured while deleting the dining location`

                sweetAlert('error',message,'alert_dining_location_Delete_Error');
            })
    }
};

